import { useMutation } from "@tanstack/react-query";
import { apiGateway } from "@contexts";
import {
  FormBody,
  FormContentContainer,
  FormHeader,
  FullScreenLoader,
} from "../../../components";
import { useEffect } from "react";
import { useEnrolmentStatusContext } from "@contexts/EnrolmentStatusContext";
import { AxiosError } from "axios";
import { ErrorType } from "../hooks/onQuestionChallengeError";

interface VerifyLoginData {
  payload: { message: string };
}

interface Props {
  setShowUserIsVerifiedSnackbar: (show: boolean) => void;
  setShowClaveUnicaErrorSnackbar: (show: boolean) => void;
}

export const VerifyClaveUnicaLogin: React.FC<Props> = ({
  setShowUserIsVerifiedSnackbar,
  setShowClaveUnicaErrorSnackbar,
}) => {
  const { getEnrolmentStatus, setCurrentStep, setCurrentStepStatus } =
    useEnrolmentStatusContext();

  const { mutate } = useMutation({
    mutationFn: () =>
      apiGateway<VerifyLoginData>({
        method: "post",
        url: "/enrolment/clave-unica/verify",
      }),
    onSuccess: async () => {
      setShowUserIsVerifiedSnackbar(true);
      await getEnrolmentStatus();
    },
    onError: async (error: AxiosError<ErrorType>) => {
      setShowClaveUnicaErrorSnackbar(true);
      const errorData = error.response?.data;
      const nextStep = errorData?.nextStep;
      const nextStepStatus = errorData?.nextStepStatus;
      if (nextStep && nextStepStatus) {
        setCurrentStep(nextStep);
        setCurrentStepStatus(nextStepStatus);
      } else {
        await getEnrolmentStatus();
      }
    },
  });
  useEffect(() => {
    // Notice that this will run twice in StricMode :(
    mutate();
  }, [mutate]);

  return (
    <>
      <FormHeader />
      <FormContentContainer flex={1} disableGutters>
        <FormBody justifyContent="center">
          <FullScreenLoader title={"Verificando identidad"} />
        </FormBody>
      </FormContentContainer>
    </>
  );
};
